import { Routes } from '../config/routes'
import { AuthGuard } from '../guards/AuthGuard'
import { SimplePageLayout } from '../layouts'
import type { RouteConfig } from '../types'
import { ApplicationAccessDenied } from '../../main/containers/ApplicationAccessDenied/ApplicationAccessDenied'

export const errorRoutes: RouteConfig[] = [
    {
        path: Routes.error.applicationAccessDenied,
        component: ApplicationAccessDenied,
        layout: SimplePageLayout,
        guard: AuthGuard,
        exact: true,
    },
]
